import { Reducer } from 'redux';

import { FeedConfigSetAction } from '../../domains/feedConfig/actions.types';
import { FeedType } from '../feeds/types';

import { FeedConfig } from './types';

const initialState: FeedConfig = {
  threadCounts: {
    [FeedType.AttachableLink]: 4,
    [FeedType.Bookmark]: 4,
    [FeedType.Group]: 4,
    [FeedType.Campaign]: 4,
    [FeedType.Home]: 4,
    [FeedType.HomeMoments]: 4,
    [FeedType.MoreForYou]: 4,
    [FeedType.Inbox]: 8,
    [FeedType.InboxDraft]: 4,
    [FeedType.InboxScheduled]: 4,
    [FeedType.LeaderEmployees]: 4,
    [FeedType.LeadersDiscovery]: 4,
    [FeedType.LeaderHighlighted]: 4,
    [FeedType.LiveEvent]: 4,
    [FeedType.MyLeaders]: 4,
    [FeedType.DiscoveryNetworkQuestion]: 4,
    [FeedType.NetworkQuestion]: 4,
    [FeedType.NetworkQuestionInbox]: 4,
    [FeedType.Promoted]: 4,
    [FeedType.StorylineAll]: 4,
    [FeedType.StorylineDiscovery]: 4,
    [FeedType.StorylineFollowed]: 4,
    [FeedType.TeamsMeeting]: 4,
    [FeedType.Thread]: 4,
    [FeedType.Topic]: 4,
    [FeedType.TopicNetworkQuestion]: 4,
    [FeedType.TopicUnified]: 4,
    [FeedType.User]: 4,
    [FeedType.UserMoments]: 4,
    [FeedType.UserWall]: 4,
    [FeedType.SingleNetworkQuestion]: 4,
    [FeedType.M365CopilotSuggestion]: 4,
  },
};

export type FeedConfigAction = FeedConfigSetAction;

const reducer: Reducer<FeedConfig, FeedConfigAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED_CONFIG.SET':
      return {
        ...state,
        threadCounts: {
          ...state.threadCounts,
          ...action.payload.feedConfig.threadCounts,
        },
      };

    default:
      return state;
  }
};

export default reducer;
